import { createFetchReducer, DefaultState } from 'store/setLocalStore';
import { combineReducers } from '@reduxjs/toolkit';
import { Action } from 'modules/types/common';
import {
  LowPriorityActionItemsResponseInterface,
  HighPriorityActionItemsResponseInterface
} from './types';
import * as actions from './actions';

export interface PriorityActionItemsState {
  lowPriorityItems: LowPriorityActionItemsState;
  highPriorityItems: HighPriorityActionItemsState;
}

export interface LowPriorityActionItemsState {
  data: LowPriorityActionItemsResponseInterface;
  requestState: any;
  lowPriorityItems: DefaultState;
  errors: [];
  isFetching: boolean;
}

export interface HighPriorityActionItemsState {
  data: HighPriorityActionItemsResponseInterface;
  requestState: any;
  highPriorityItems: DefaultState;
  errors: [];
  isFetching: boolean;
}

const lowPriorityItemsReducer = createFetchReducer<LowPriorityActionItemsResponseInterface>(
  actions.GET_LOW_PRIORITY_ITEMS,
  true
);

const highPriorityItemsReducer = createFetchReducer<HighPriorityActionItemsResponseInterface>(
  actions.GET_HIGH_PRIORITY_ITEMS,
  true
);

const lowPriorityItems = (state: LowPriorityActionItemsState, action: Action) => {
  return lowPriorityItemsReducer(state, action);
};

const highPriorityItems = (state: HighPriorityActionItemsState, action: Action) => {
  return highPriorityItemsReducer(state, action);
};

export default combineReducers({
  lowPriorityItems,
  highPriorityItems
});
